module.exports = __webpack_public_path__ + "static/splurty-18177d00e006380f6e4aafc6e1722723.png";